import userRole from './userRole'
export default {
  mixins: [userRole],
  computed: {
    objektasMap() {
      return [
        {
          value: 'sutartinis-hipoteka',
          text: 'Sutartinė hipoteka',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'sandoris',
              text: 'Įregistravimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
          ],
        },
        {
          value: 'sutartinis-ikeitimas',
          text: 'Sutartinis įkeitimas',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'sandoris',
              text: 'Įregistravimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
          ],
        },
        {
          value: 'priverstinis-hipoteka',
          text: 'Priverstinė hipoteka',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'nustatymas',
              text: 'Įregistravimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
          ],
        },
        {
          value: 'priverstinis-ikeitimas',
          text: 'Priverstinis įkeitimas',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'nustatymas',
              text: 'Įregistravimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
          ],
        },
        {
          value: 'vykdomasis',
          text: 'Notaro vykdomasis įrašas',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'atlikimas',
              text: 'Atlikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'panaikinimas',
              text: 'Panaikinimas',
            },
          ],
        },
        {
          value: 'sutartis-atpirkimas',
          text: 'Pirkimo – pardavimo su atpirkimo teise sutartis',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'teikimas',
              text: 'Teikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
            {
              value: 'neisregistruoti',
              text: 'Prašymas neišregistruoti automatiškai',
            },
            {
              value: 'atpirkimas',
              text: 'Pageidavimas pasinaudoti atpirkimo teise',
            },
            {
              value: 'atsaukimas',
              text: 'Pageidavimo pasinaudoti atpirkimo teise atšaukimas',
            },
          ],
        },
        {
          value: 'sutartis-issimoketinas',
          text: 'Pirkimo - pardavimo išsimokėtinai sutartis',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'teikimas',
              text: 'Teikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
            {
              value: 'neisregistruoti',
              text: 'Prašymas neišregistruoti automatiškai',
            },
          ],
        },
        {
          value: 'sutartis-lizingas',
          text: 'Lizingo (finansinės nuomos) sutartis',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'teikimas',
              text: 'Teikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
            {
              value: 'neisregistruoti',
              text: 'Prašymas neišregistruoti automatiškai',
            },
          ],
        },
        {
          value: 'sutartis-nuoma',
          text: 'Neregistruojamų daiktų nuomos sutartis',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'teikimas',
              text: 'Teikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
            {
              value: 'neisregistruoti',
              text: 'Prašymas neišregistruoti automatiškai',
            },
          ],
        },
        {
          value: 'sutartis-panauda',
          text: 'Neregistruojamų daiktų panaudos sutartis',
          role: [
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
          veiksmai: [
            {
              value: 'teikimas',
              text: 'Teikimas',
            },
            {
              value: 'pakeitimas',
              text: 'Pakeitimas',
            },
            {
              value: 'pabaiga',
              text: 'Pabaiga',
            },
            {
              value: 'neisregistruoti',
              text: 'Prašymas neišregistruoti automatiškai',
            },
          ],
        },
      ]
    },
    objektasList() {
      return this.objektasMap
        .filter(objektas => {
          return this.roleOr(objektas.role)
        })
        .map(item => {
          return {
            value: item.value,
            text: item.text,
          }
        })
    },
    veiksmasList() {
      let objektas = this.objektasMap.find(
        e => e.value == this.extraData.objektas
      )
      return objektas ? objektas.veiksmai : []
    },
    enableVeiksmas() {
      return this.extraData.objektas
    },
    filteredPranesimasRusys() {
      return this.pranesimas_rusys.filter(item => {
        if (!this.extraData.objektas && this.extraData.veiksmas.length === 0) {
          return true
        }

        if (this.extraData.veiksmas.length === 0) {
          if (this.extraData.objektas !== 'vykdomasis') {
            return (
              item.value.includes(this.extraData.objektas) &&
              !item.value.includes('vykdomasis')
            )
          }
          return item.value.includes(this.extraData.objektas)
        }

        return (
          this.extraData.veiksmas.filter(veiksmas => {
            return item.value.includes(`${this.extraData.objektas}-${veiksmas}`)
          }).length > 0
        )
      })
    },
    pranesimasRusisVeiksmai() {
      return [
        {
          value: 1,
          text: 'Sudarymas',
        },
        {
          value: 2,
          text: 'Teikimas',
        },
      ]
    },
  },
  methods: {
    objektasChange() {
      this.extraData.veiksmas = []
      this.clearRusis()
    },
    veiksmasChange() {
      this.clearRusis()
    },
  },
}
